const FeatureCard = ({ icon, title, description }) => (
  <div className="bg-white p-6 lg:p-8 rounded-xl shadow-sm border border-gray-200 hover:shadow-lg hover:border-[#01CC54]/30 transition-all duration-300 group">
    <div className="flex items-start mb-4">
      <div className="flex-shrink-0 p-2 rounded-lg bg-gray-50 group-hover:bg-[#01CC54]/10 transition-colors duration-300">
        {icon}
      </div>
      <h3 className="text-lg font-semibold text-gray-900 ml-3 pt-1">{title}</h3>
    </div>
    <p className="text-gray-600 leading-relaxed">{description}</p>
  </div>
);

export default FeatureCard;
